// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file options.proto (package pomerium.config, syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file options.proto.
 */
export const file_options: GenFile = /*@__PURE__*/
  fileDesc("Cg1vcHRpb25zLnByb3RvEg9wb21lcml1bS5jb25maWc6PQoJc2Vuc2l0aXZlEh0uZ29vZ2xlLnByb3RvYnVmLkZpZWxkT3B0aW9ucxjtygUgASgIUglzZW5zaXRpdmVCLlosZ2l0aHViLmNvbS9wb21lcml1bS9wb21lcml1bS9wa2cvZ3JwYy9jb25maWdiBnByb3RvMw", [file_google_protobuf_descriptor]);

/**
 * sensitive marks a field as carrying secret material — keys, tokens,
 * shared secrets, signing material — whose value must not be exposed to
 * untrusted readers or accepted from untrusted writers. Tools that surface
 * ConfigService to such audiences are expected to redact and merge these
 * fields appropriately.
 *
 * @generated from extension: bool sensitive = 91501;
 */
export const sensitive: GenExtension<FieldOptions, boolean> = /*@__PURE__*/
  extDesc(file_options, 0);

